/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjustsubtract2Inputs */

const zh_adminsubs_adjustsubtract2 = /** @type {(inputs: Adminsubs_Adjustsubtract2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减少`)
};

const en_adminsubs_adjustsubtract2 = /** @type {(inputs: Adminsubs_Adjustsubtract2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract`)
};

const es_adminsubs_adjustsubtract2 = /** @type {(inputs: Adminsubs_Adjustsubtract2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restar`)
};

/**
* | output |
* | --- |
* | "Subtract" |
*
* @param {Adminsubs_Adjustsubtract2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjustsubtract2 = /** @type {((inputs?: Adminsubs_Adjustsubtract2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjustsubtract2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjustsubtract2(inputs)
	if (locale === "en") return en_adminsubs_adjustsubtract2(inputs)
	return es_adminsubs_adjustsubtract2(inputs)
});
export { adminsubs_adjustsubtract2 as "adminSubs_adjustSubtract" }